import script from "./RecentEntries.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecentEntries.vue?vue&type=script&lang=ts&setup=true"

import "./RecentEntries.vue?vue&type=style&index=0&id=e59301ec&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e59301ec"]])

export default __exports__